export default __webpack_public_path__ + "static/media/Landing_Orange_Arch.fc57eb2b.png";